import React, { ComponentType } from 'react'
import {
  InterstitialPageMetadataFragment,
  InterstitialPathFlowPageMetadataType
} from '#src/generated/graphql'
import { extractPageInterstitialData } from '#src/services/path'
import { usePathContext } from '../PathContext'

export interface InterstitialProps {
  interstitialMetadata: InterstitialPageMetadataFragment
  submitButtonText: string
  categorySlug?: string
  title?: string
  body?: string
}

export type InterstitialMap = {
  [name in InterstitialPathFlowPageMetadataType]?: ComponentType<InterstitialProps>
}

interface InterstitialBuilderProps {
  interstitialMap: InterstitialMap
  submitButtonText: string
  categorySlug?: string
}

const InterstitialBuilder: React.SFC<InterstitialBuilderProps> = ({ interstitialMap, ...rest }) => {
  const pathContext = usePathContext()

  // Extract the interstitial meta data from the page, if it exists
  const interstitialMetadata = extractPageInterstitialData(pathContext.pathFlowPage.metadata)
  if (!interstitialMetadata) {
    return null
  }

  // Pick the interstitial type and render it
  const interstitialType = interstitialMetadata.interstitialType

  let ActiveInterstitial: React.ComponentType<InterstitialProps> | undefined
  if (interstitialMap[interstitialType]) {
    ActiveInterstitial = interstitialMap[interstitialType]
  }

  if (!ActiveInterstitial) {
    throw new Error(`Undefined interstitial referenced, [${interstitialType}]`)
  }

  return (
    <ActiveInterstitial
      key={pathContext.pathFlowPage.slug}
      interstitialMetadata={interstitialMetadata}
      {...rest}
    />
  )
}

export default InterstitialBuilder
